<script  setup>


import {reactive, ref} from "vue";
import {ElCol, ElDatePicker, ElLoading, ElMessage, ElRow} from "element-plus";
import {
    Delete
} from '@element-plus/icons-vue'
import axios from "axios";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';


const props = defineProps({
    hdata:Object,
    mealplans:Object,
    roomtypes:Object,
});


const data=props.hdata;
const mealplans=props.mealplans;
const roomtypes=props.roomtypes;

const ruleFormRef = ref();

const rules = reactive({
    name: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    type: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    gender: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    dob: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
});

const addform=reactive(
    data
)

const blankdata = JSON.parse(JSON.stringify(data.flights[0]));

const faretypes=["Refundable",'Non-Refundable'];

const addhotelroom=(index)=>{
    addform.flights[index].rooms.push({ "type": "", "adt": 1, "chd": 0, "mb": "", "paxes": [] });
}

const deleteroom=(index,index1)=>{
    addform.flights[index].rooms.splice(index1, 1);
}

const addhotel=()=>{
    addform.flights.push(blankdata);
}
const removehotel=(index)=>{
    addform.flights.splice(index, 1);
}


const generating=ref(false);

const dialogVisible = ref(false)
const pdfUrl = ref('')

const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate(async (valid, fields) => {

        if (valid) {
            const loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            try {
                const response = await axios.post('/enquiry/vouchers/flightvoucherpreview', addform, {
                    responseType: 'blob'
                })
                loading.close()

                const blob = new Blob([response.data], {type: 'application/pdf'})
                pdfUrl.value = URL.createObjectURL(blob)
                dialogVisible.value = true
            } catch (error) {
                loading.close()
            }



        }
    })
}


function handlePaste(event, index, index1) {
    const itemsClipboard = event.clipboardData.items;
    for (let item of itemsClipboard) {
        if (item.type.indexOf("image") === 0) {
            const file = item.getAsFile();
            const reader = new FileReader();
            reader.onload = (e) => {
                addform.flights[index].pax[index1].qrcode=e.target.result; // base64 string
            };
            reader.readAsDataURL(file);
        }
    }
}

</script>

<template>


        <nav class="navbar navbar-expand navbar-primary navbar-dark">
            <!-- Left navbar links -->
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link"  href="#" role="button">TRIP ID - {{data.enquiry_id}}</a>

                </li>


            </ul>
            <!-- Right navbar links -->
            <ul class="navbar-nav ml-auto">


                <li class="nav-item ml-2" >

                    <a class="nav-link btn-outline-primary"  :href="'/viewenquiry?id='+data.encryptedid" role="button">BACK</a>
                </li>


            </ul>

        </nav>


    <el-main>
        <el-row :gutter="10">
            <el-col class="pr-w100 text-right" :span="24">
                <el-button type="primary" size="default"  @click="addhotel()">Add Flight</el-button>
                <el-button class="ml-3" type="primary" size="default"  @click="submitForm(ruleFormRef)" :disabled="generating" :loading="generating">Generate Voucher</el-button>

            </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col class="pr-w100" :span="24">
                <el-form
                    ref="ruleFormRef"
                    :model="addform"
                    status-icon
                    label-width="auto"
                    class="demo-ruleForm"
                    label-position="top"
                    size="small"
                    :rules="rules"

                >
                    <el-row :gutter="10">
                        <el-col class="pr-w100 text-right" :span="4">
                            <el-form-item label="Airline PNR" :prop="'airlinepnr'"
                                          :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                <el-input v-model="addform.airlinepnr"  placeholder="Airline PNR" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-card class="mt-4" v-for="(flight, index) in addform.flights">
                        <el-row :gutter="10">
                            <el-col class="pr-w100 text-right" :span="24">
                                <el-button type="danger" size="small" class="mb-3"  @click="removehotel(index)">Remove Flight</el-button>

                            </el-col>
                        </el-row>
                        <el-row :gutter="20" >
                            <el-col :span="3" >
                                <el-form-item label="Airline" :prop="'flights.' + index + '.airline'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="flight.airline"  placeholder="Airline" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Flight Number" :prop="'flights.' + index + '.flightNumber'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="flight.flightNumber"  placeholder="Flight Number" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Class" :prop="'flights.' + index + '.class'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="flight.class"  placeholder="Class" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="3">
                                <el-form-item label="Fare Type"  :prop="'flights.' + index + '.faretype'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-select
                                        placeholder="Fare Type"
                                        style="width: 100%"
                                        v-model="flight.faretype"
                                    >
                                        <el-option
                                            v-for="item in faretypes"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        />

                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" >
                                <el-form-item label="Duration" :prop="'flights.' + index + '.duration'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="flight.duration"  placeholder="Duration" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="2" >
                                <el-form-item label="Layover" :prop="'flights.' + index + '.layover'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="flight.layover"  placeholder="Layover" />
                                </el-form-item>

                            </el-col>
                        </el-row>
                        <el-row :gutter="20" >
                            <el-col :span="24" >
                                <el-text tag="b" size="large">Departure</el-text>
                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="City" :prop="'flights.' + index + '.departure.city'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="flight.departure.city"  placeholder="City" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="2" >
                                <el-form-item label="Code" :prop="'flights.' + index + '.departure.code'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="flight.departure.code"  placeholder="Code" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="5" >
                                <el-form-item label="Airport" :prop="'flights.' + index + '.departure.airport'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="flight.departure.airport"  placeholder="Airport" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="5" >
                                <el-form-item label="Date/Time" :prop="'flights.' + index + '.departure.datetime'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-date-picker
                                        v-model="flight.departure.datetime"
                                        type="datetime"
                                        placeholder="Departure Date/Time"
                                        value-format="YYYY-MM-DD HH:mm"
                                        format="MMM DD, YYYY hh:mm a"
                                        date-format="MMM DD, YYYY"
                                        time-format="HH:mm"
                                    >
                                    </el-date-picker>

                                </el-form-item>

                            </el-col>

                        </el-row>
                        <el-row :gutter="20" >
                            <el-col :span="24" >
                                <el-text tag="b" size="large">Arrival</el-text>
                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="City" :prop="'flights.' + index + '.arrives.city'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="flight.arrives.city"  placeholder="City" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="2" >
                                <el-form-item label="Code" :prop="'flights.' + index + '.arrives.code'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="flight.arrives.code"  placeholder="Code" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="5" >
                                <el-form-item label="Airport" :prop="'flights.' + index + '.arrives.airport'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="flight.arrives.airport"  placeholder="Airport" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="5" >
                                <el-form-item label="Date/Time" :prop="'flights.' + index + '.arrives.datetime'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-date-picker
                                        v-model="flight.arrives.datetime"
                                        type="datetime"
                                        placeholder="Departure Date/Time"
                                        value-format="YYYY-MM-DD HH:mm"
                                        format="MMM DD, YYYY hh:mm a"
                                        date-format="MMM DD, YYYY"
                                        time-format="HH:mm"
                                    >
                                    </el-date-picker>

                                </el-form-item>

                            </el-col>

                        </el-row>
                        <el-row :gutter="20" >
                            <el-col :span="24" >
                                <el-text tag="b" size="large">Traveller Details </el-text>
                            </el-col>

                        </el-row>
                        <el-row :gutter="20"  v-for="(pax, index1) in flight.pax">

                            <el-col :span="3" >
                                <el-form-item label="Traveller Name" :prop="'flights.' + index + '.pax.' + index1 + '.name'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="pax.name"  placeholder="Traveller Name" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Meal" :prop="'flights.' + index + '.pax.' + index1 + '.meal'"
                                              >
                                    <el-input v-model="pax.meal"  placeholder="Meal" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Check-In Baggage" :prop="'flights.' + index + '.pax.' + index1 + '.checkinbaggage'"
                                             >
                                    <el-input v-model="pax.checkinbaggage"  placeholder="Check-In Baggage" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Cabin Baggage" :prop="'flights.' + index + '.pax.' + index1 + '.cabininbaggage'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="pax.cabininbaggage"  placeholder="Cabin Baggage" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Seat" :prop="'flights.' + index + '.pax.' + index1 + '.seat'"
                                             >
                                    <el-input v-model="pax.seat"  placeholder="Seat" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Ticket No." :prop="'flights.' + index + '.pax.' + index1 + '.ticketno'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="pax.ticketno"  placeholder="Ticket No." />
                                </el-form-item>

                            </el-col>
                            <el-col :span="4" >
                                <el-form-item label="Bar Code" :prop="'flights.' + index + '.pax.' + index1 + '.qrcode'"
                                              >
                                    <el-image
                                         v-if="pax.qrcode!=''"
                                        :src="pax.qrcode"
                                        style="width: 100%;"
                                        fit="cover"
                                    />
                                    <el-input
                                        ref="textInput"
                                        placeholder="Paste image here (Ctrl+V)"
                                        @paste="event => handlePaste(event, index,index1)"

                                    />
                                </el-form-item>

                            </el-col>


                        </el-row>
                    </el-card>




                    <el-card class="mt-4">
                        <p>
                            <el-text tag="b"  size="large">Important Note:</el-text>
                        </p>
                        <quill-editor theme="snow" v-model:content="addform.importantnote" contentType="html"></quill-editor>
                    </el-card>

                </el-form>

            </el-col>
        </el-row>

    </el-main>

    <el-dialog v-model="dialogVisible" width="80%" title="PDF Preview">
        <iframe
            v-if="pdfUrl"
            :src="pdfUrl"
            width="100%"
            height="600px"
            frameborder="0"
        ></iframe>
    </el-dialog>


</template>



<style scoped>

</style>
